exports.components = {
  "component---src-pages-asistencia-tecnica-js": () => import("./../../../src/pages/asistencia_tecnica.js" /* webpackChunkName: "component---src-pages-asistencia-tecnica-js" */),
  "component---src-pages-consultar-estado-js": () => import("./../../../src/pages/consultar_estado.js" /* webpackChunkName: "component---src-pages-consultar-estado-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

